module.exports = __webpack_public_path__ + "media/images/anonymous-ececb07991bfa3a2690d8b0396283143.svg";